import { pick } from 'lodash-es';


/* Adapted from dataSource.filter in Material */
export function searchObject<T>(data: T, filter: string): boolean {
  // Transform the data into a lowercase string of all property values.
  const dataStr = Object.keys(data).reduce((currentTerm: string, key: string) => {
    // Use an obscure Unicode character to delimit the words in the concatenated string.
    // This avoids matches where the values of two columns combined will match the user's query
    // (e.g. `Flute` and `Stop` will match `Test`). The character is intended to be something
    // that has a very low chance of being typed in by somebody in a text field. This one in
    // particular is "White up-pointing triangle with dot" from
    // https://en.wikipedia.org/wiki/List_of_Unicode_characters
    return currentTerm + (data as { [key: string]: any })[key] + '◬';
  }, '').toLowerCase();

  // Transform the filter by converting it to lowercase and removing whitespace.
  const transformedFilter = filter.trim().toLowerCase();

  return dataStr.indexOf(transformedFilter) !== -1;
}

/* Same as searchObject but only for specific keys (DB objects tend to have lots of extra fields not displayed)  */
export function searchObjectKeys<T>(data: T, keys: Array<keyof T>, filter: string): boolean {
  const picked = pick(data, keys);
  return searchObject(picked, filter);
}
